<template>
  <q-menu
    content-class="q-px-sm border-radius-12"
    v-bind="$attrs"
    auto-close
  >
    <q-list
      class="context-menu-list"
      separator
    >
      <q-item
        v-for="(node, index) in elements"
        :key="index"
        class="q-px-none q-py-sm"
      >
        <q-item-section>
          <VNode
            :node="node"
            tag="span"
          />
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>
import VNode from 'common/components/VNode';

export default {
  name: 'ContextMenu',
  components: { VNode },
  props: {
    // Required to re-render the action list
    // when actions are generated dynamically
    // and may change in the future
    actions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      elements: [],
    };
  },
  watch: {
    actions: {
      deep: true,
      immediate: true,
      handler() {
        this.setElements();
      },
    },
  },
  methods: {
    setElements() {
      this.elements = this.$slots.default.filter((item) => item.tag !== undefined);
    },
  },
};
</script>

<style lang="scss">
.context-menu-list {
  a,
  button {
    transition: all 0.25s ease;
  }

  :is(a, button):hover {
    background: $primary !important;
  }
}
</style>
